import { curry2 } from '@most/prelude';
export var next = curry2(function next(value, subject) {
    return subject.next(value);
});
//# sourceMappingURL=next.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/most-subject/lib/es2015/combinators/next.js
// module id = 863
// module chunks = 0